import { render, staticRenderFns } from "./Alert.vue?vue&type=template&id=a010cc18&scoped=true"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"
import style0 from "./Alert.vue?vue&type=style&index=0&id=a010cc18&prod&scoped=true&lang=css"
import style1 from "./Alert.vue?vue&type=style&index=1&id=a010cc18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a010cc18",
  null
  
)

export default component.exports